export default __webpack_public_path__ + "static/media/vbLogo.e2b97447.png";